/* ==============================================
   PP Scroll Reveal — premium fade-up on scroll
   ============================================== */

(function () {
  // Don't run in the theme editor (sections can be dragged)
  if (window.Shopify && window.Shopify.designMode) return;

  const THRESHOLD = 0.12; // how much of section must be visible before triggering
  const STAGGER   = 80;   // ms between each section when multiple enter at once

  // Sections to skip — hero always visible immediately
  const SKIP = ['section-pp-hero', 'shopify-section-header', 'shopify-section-footer'];

  function shouldSkip(el) {
    return SKIP.some(cls => el.id && el.id.includes('pp_hero'));
  }

  function init() {
    const sections = document.querySelectorAll('.shopify-section');

    const observer = new IntersectionObserver(function (entries) {
      let delay = 0;
      entries.forEach(function (entry) {
        if (entry.isIntersecting && !entry.target.classList.contains('pp-revealed')) {
          const el = entry.target;
          setTimeout(function () {
            el.classList.add('pp-revealed');
          }, delay);
          delay += STAGGER;
          observer.unobserve(el);
        }
      });
    }, {
      threshold: THRESHOLD,
      rootMargin: '0px 0px -40px 0px'
    });

    sections.forEach(function (section) {
      // Hero and header skip — they appear instantly
      if (shouldSkip(section)) {
        section.classList.add('pp-revealed');
        return;
      }

      // If section is already in view on load (above fold), reveal immediately
      const rect = section.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.85) {
        section.classList.add('pp-revealed');
        return;
      }

      section.classList.add('pp-reveal');
      observer.observe(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
